export const INVITATION_STATUS = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  UNANSWERED: 'UNANSWERED',
  CANCELED: 'CANCELED',
  EXPIRED: 'EXPIRED',
  TEAM_DISABLED: 'EXPIRED_INVITATION',
};
